import styled from 'styled-components';
const MyDiv = styled.div`
.select_box {
font-family: Poppins;
font-weight: 500;
font-size: 10px;
line-height: 100%;
letter-spacing: 0%;
}

`;

export default MyDiv